import { __awaiter } from "tslib";
import readyState from 'ready-state';
import LazyLoad from '@slickdeals/blueprint-twig/javascript/core/lazyLoad';
import Injector from '@slickdeals/durango/dist/javascript/core/injector';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import SearchResultsObservable from '../observers/searchResultsObservable';
import BlueshiftObserver from '../blueshift/blueshiftObserver';
import Blueshift from '../blueshift/blueshift';
import './standalonePageEntrypointBanner';
import LoyaltyOfferService from '../services/loyaltyOfferService';
import Heap from '../heap/heap';
import { name as CashbackSearchResultsBannerInjectorName } from '../loyalty/cashbackSearchResultsBannerInjector';
import '@slickdeals/blueprint-twig/javascript/components/icon';
import '../patterns/inlineResponse';
import { initPage } from '../utilities/initPage';
/** The name of the module */
export const name = 'Search';
initPage();
// Register observable with observer
const observer = new BlueshiftObserver(new Blueshift());
observer.observe(new SearchResultsObservable());
const addCashbackBannerPromo = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const offersJSON = yield LoyaltyOfferService.getOffers();
    const { offers } = offersJSON;
    const banner = document.querySelector('[data-promo-type="cashbackSearchResultsBanner"]');
    const offer = offers[Object.keys(offers)[0]];
    if (banner) {
        const heap = new Heap();
        heap.track(`${banner.dataset.trackingKey} - Impression`, { testVariant: banner.dataset.variantType }).catch(() => { });
    }
    else if (!banner && offer) {
        const props = {
            cashbackRate: offer.rate,
            ctaText: offersJSON.ctaText,
            ctaUrl: offersJSON.ctaUrl,
            storeName: offer.storeName,
            trackingKey: (_a = offersJSON.trackingKey) !== null && _a !== void 0 ? _a : 'Cashback Search Banner',
            testVariant: (_b = offersJSON.testVariant) !== null && _b !== void 0 ? _b : null,
        };
        const bannerInjector = Injector.resolve(CashbackSearchResultsBannerInjectorName);
        bannerInjector.injectBanner(props);
    }
});
readyState.domready.then(() => __awaiter(void 0, void 0, void 0, function* () {
    new LazyLoad(); // eslint-disable-line no-new
    try {
        yield addCashbackBannerPromo();
    }
    catch (_c) {
        Logger.error('Unable to load loyalty offers');
    }
}));
